module.exports = __webpack_public_path__ + "img/JMWLP_studio-page-banner.8e0e0327.jpg";